import React from 'react';
import styled from 'styled-components';
import { DataTable } from 'primereact/datatable';
import { Column, ColumnProps } from 'primereact/column';
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";

interface TableProps {
  data: any[];
  columns: ColumnProps[];
  tableStyle?: Record<any, any>;
  selection?: any[];
  onSelectionChange?: (e: any) => void;
  onPageChange?: (event: PaginatorPageChangeEvent) => void;
  currentPage: number;
  pageCount: number;
  total: number;
  onNavigateByRowClick?: (id: string) => void;
  hidePaginator?: boolean;
}

export const Table: React.FC<TableProps> = props => {
  const { data, columns, tableStyle, selection, total, currentPage, pageCount, onSelectionChange, onPageChange, onNavigateByRowClick, hidePaginator } = props;
  return (
    <Wrapper>
      <DataTable value={data} tableStyle={tableStyle} selection={selection} onSelectionChange={onSelectionChange} onRowClick={(e) => {
        if (
          (e.originalEvent.target as HTMLElement).closest('input[type="checkbox"]')
        ) {
          return;
        }
        onNavigateByRowClick && onNavigateByRowClick(e.data.id);
      }}>
        {selection && (
          <Column
            selectionMode="multiple"
            headerStyle={{
              width: '15px',
              border: 'none',
              borderTopLeftRadius: 10,
              borderBottomLeftRadius: 10,
              overflow: 'hidden'
            }}
          />
        )}
        {columns.map((col, i) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            body={col.body}
            headerStyle={{
              padding: '12px 15px',
              border: 'none',
              ...(i + 1 === columns.length ? {
                borderTopRightRadius: 10,
                borderBottomRightRadius: 10,
                overflow: 'hidden'
              } : {})
            }}
          />
        ))}
      </DataTable>
      {!hidePaginator && !!onPageChange && data.length > 0 && (
        <PaginatorWrapper>
          <Paginator first={currentPage} rows={pageCount} totalRecords={total} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange} />
        </PaginatorWrapper>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: auto;
  flex: 0 0 auto;
  
  thead tr td:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    overflow: hidden;
  }

  thead tr td:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow: hidden;
  }
`;

const PaginatorWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
